export const STORE = 'SIGNIN_UP';
export const SEND_VERIFICATION_CODE = 'SEND_VERIFICATION_CODE';
export const VERIFY_CODE = 'VERIFY_CODE';
